import React from 'react';
import createSvgIcon from '@mui/material/utils/createSvgIcon';

export default createSvgIcon(
  <svg
    width='29'
    height='32'
    viewBox='0 0 29 32'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clip-path='url(#clip0_4514_152502)'>
      <path
        d='M14.5 31.132C22.5081 31.132 29 24.3578 29 16.0015C29 7.64522 22.5081 0.871094 14.5 0.871094C6.49187 0.871094 0 7.64522 0 16.0015C0 24.3578 6.49187 31.132 14.5 31.132Z'
        fill='currentColor'
        fill-opacity='0.25'
      />
      <path
        d='M8 25.5841V23.0623H21V25.5841H8ZM13.2 20.5406V10.233L9.82 13.4797L8 11.7145L14.5 5.41016L21 11.7145L19.18 13.4797L15.8 10.233V20.5406H13.2Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_4514_152502'>
        <rect
          width='29'
          height='30.2609'
          fill='white'
          transform='translate(0 0.871094)'
        />
      </clipPath>
    </defs>
  </svg>,
  'UpdateAvailable'
);
